import * as React from 'react';
import { H1, HTML, Text } from "../../common"

import room from '../../images/library.jpg';
import ContentSplit from '../../components/contentSplit';

const Welcome: React.FC = (props) => {
    return (
        <ContentSplit leadWithImage theme='navy' rightImage={room} imagePosition='bottom right' leftContent={
            <>
                <H1>Welcome!</H1>
                <HTML>
                    <Text>I am thrilled to welcome you to the Friends' Area — a members-only domain, where you can delve into a treasure trove of exclusive digital content.</Text>
                    <Text>We are pleased to offer our members unlimited access to the complete <em>Faunus</em> archive, available in PDF format and we've made browsing the collection much easier. Selecting any edition gives you a quick-glance summary of it's contents and our powerful search tool allows you to filter articles by keyword.</Text>
                    <Text>As well as Faunus, you can also view every <em>Machenalia</em> newsletter since 2015. We are hoping to digitise some of the older editions, for now please enjoy this historic material.</Text>
                    <Text>Videos from our most recent Annual General Meetings can be found below, along with financial reports.</Text> 
                    <Text>I hope you enjoy what you discover here and thank you for your continued support.</Text>
                    <Text>John Galantini, Digital Services<br />January, 2026</Text>
                </HTML>
            </>
        } />
    )
}

export default Welcome;